import emailInvoicePrompt from "emun.invoice/email-invoice-prompt";
import invFilters from "emun.invoice/inv/inv-container.filters";
import sortOptions from "emun.invoice/inv/inv-container.sort-options";
import Invoice from "emun.invoice/inv/inv.model";
import PrintInvoiceOptions from "emun.invoice/invoice-print";
import invoiceConfig from "emun.invoice/invoice.config";
import "emun.invoice/picker/invoice-picker-cards.htm";
import "emun.invoice/picker/invoice-picker-table.htm";
import dateRanges from "emun.order/order-container.date-ranges";
import orderConfig from "emun.order/order.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";

export const views = {
  table: "table",
  //  cards: "th-large"
};

export default class InvoicePickerController extends BasicAutoQueryController {
  constructor(options) {
    super();
    const $ctrl = this;
    $ctrl.dateRanges = dateRanges;
    $ctrl.dateRange = dateRanges[0].id;
    $ctrl.selected = {};
    Object.assign($ctrl, options);
    $ctrl.setInvoiceIds();
    $ctrl.query = new AutoQuery($ctrl.getInvoiceQueryOptions());
    $ctrl.bus = $ctrl.query.bus;
    $ctrl.orderConfig = orderConfig;
    $ctrl.invoiceConfig = invoiceConfig;
    //$ctrl.viewSelectionsChanged(); //load()
  }

  templateUrl = () => `invoice-picker-${this.query.view}.htm`;

  selectAll() {
    const $ctrl = this;
    $ctrl.query.results.forEach((p) => ($ctrl.selected[p.id] = true));
    this.setInvoiceIds();
  }
  clearAll() {
    this.selected = {};
    this.setInvoiceIds();
  }
  canClear() {
    return Object.keys(this.selected).length;
  }

  isSelected(invoice) {
    return !!this.selected[invoice.id];
  }

  setInvoiceIds() {
    this.invoiceIds = Object.keys(this.selected || {});
  }

  selectionsLabel() {
    const { invoiceIds: keys = [] } = this;
    if (keys.length > 4)
      return `Selected: ${keys.slice(0, 4).join(", ")} and ${
        keys.length - 4
      } more...`;
    if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
    return "No selections";
  }

  hasSelections = () => Object.keys(this.selected).length > 0;

  viewSelectionsChanged() {
    const $ctrl = this;
    const idIn = $ctrl.viewSelections
      ? Object.keys($ctrl.selected || {}).join(",")
      : null;
    $ctrl.query.clearRefinements(false);
    $ctrl.query.filter("IdIn", idIn);
  }

  toggle(invoice) {
    const $ctrl = this;
    console.log("toggle", invoice.id, $ctrl.selected, invoice);

    if ($ctrl.single) {
      $ctrl.$close(invoice);
    } else if (invoice.id in $ctrl.selected) {
      delete $ctrl.selected[invoice.id];
      $ctrl.onInvoiceUnSelected &&
        $ctrl.onInvoiceUnSelected({ $invoice: invoice, ...$ctrl });
    } else {
      $ctrl.selected[invoice.id] = true;
      $ctrl.onInvoiceSelected &&
        $ctrl.onInvoiceSelected({ $invoice: invoice, ...$ctrl });
    }
    this.setInvoiceIds();
  }
  select(invoice) {
    const $ctrl = this;
    $ctrl.$close([invoice]);
  }

  $onDestroy() {
    this.query.dispose();
  }

  emailInvoice() {
    //emailInvoicePrompt(options);
    const $ctrl = this;
    return emailInvoicePrompt({
      id: $ctrl.invoiceIds.join(","),
      invoiceNumber: $ctrl.invoiceIds.join(","),
      from: $ctrl.$session.email,
      clientName: $ctrl.$session.clientName,
      IncludeImages: false,
      IncludeBarcodes: false,
      OrderBy: "strProductID",
    });
  }

  printInvoice() {
    const $ctrl = this;
    return PrintInvoiceOptions({
      request: {
        id: $ctrl.invoiceIds.join(","),
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }
  exportLines(reportName) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        reportName +
        " &output=xlsx&QuickReportID=" +
        reportName +
        "&QuickReportName=" +
        reportName +
        "&@strOrderNumber=" +
        $ctrl.invoiceIds.join(",")
    );

    return (location.href = url);
  }

  //deleteOrder() {
  //	const $ctrl = this;
  //	let request = {
  //		OrderIds: $ctrl.orderIds.join(',')
  //	};
  //	return modals.confirm("Delete the selected order(s)?  Warning: All selected orders will be made inactive.  To undo this go to View Inactive Orders.", "Delete Order").result.then(function () {
  //		$ctrl.bus.send('DeleteOrders.json', request).then(function() {
  //			$ctrl.query.load();
  //		});
  //	});
  //}

  getInvoiceQueryOptions() {
    const $ctrl = this;
    var filters = [];
    invFilters.forEach(function (obj) {
      filters.push(obj);
    });
    return {
      url: `QueryInvoicesJoin.json`, //?StatusNotEqualTo=Cart',
      fields:
        invoiceConfig.invoiceFields ||
        "Id,InvoiceDate,RetailerId,DueDate,Status,InvoiceTotal,CreditMemoTotal,TotalFreight,SalesRepId,PaymentTermsId,CompanyName,TransactionType,PONumber,OrderNumber,Division,TagFor,Reason,Description,RetailerEmail,SalesRepName,InvoiceBalance",
      tagTotalsUrl: `QueryInvoicesJoin.json`,
      orderBy: "-InvoiceDate,-Id",
      disableQueryString: !!$ctrl.disableQueryString,
      pageSize: 12,
      criteria: $ctrl.criteria,
      views,
      view: $ctrl.$pageConfig.is("gt-md") ? "table" : "cards",
      filters,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
      scrub(res) {
        res.data.results = res.data.results.map((inv) => new Invoice(inv));
      },
    };
  }
  //getQuery() {
  //	const $ctrl = this;
  //	var filters = [];
  //	const retailerId =
  //		$ctrl.retailerId || ($ctrl.customer && $ctrl.customer.id);
  //	if (retailerId) {
  //		//url = url + `?retailerId=${encodeURIComponent(retailerId)}`;
  //		filters.push({
  //			groupBy: "ShippingLocationAddress",
  //			title: "Ship Address",
  //		});
  //	}
  //	invFilters.forEach(function (obj) {
  //		filters.push(obj);
  //	});

  //	return {
  //		url: `QueryInvoicesJoin.json?op=InvContainer`,
  //		fields:
  //			invoiceConfig.invoiceFields ||
  //			"Id,InvoiceDate,RetailerId,DueDate,Status,InvoiceTotal,CreditMemoTotal,TotalFreight,SalesRepId,PaymentTermsId,CompanyName,TransactionType,PONumber,OrderNumber,Division,TagFor,Reason,Description,RetailerEmail,SalesRepName,InvoiceBalance",
  //		orderBy: "-InvoiceDate,-Id",
  //		disableQueryString: !!$ctrl.disableQueryString,
  //		pageSize: 12,
  //		criteria: {
  //			retailerId: $ctrl.customer ? $ctrl.customer.id : undefined,
  //			productId: $ctrl.productId,
  //			[`TransactionType${$ctrl.mode === "creditmemo" ? "" : "NotEqualTo"}`]:
  //				"CreditMemo",
  //		},
  //		views,
  //		view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
  //		filters,
  //		hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
  //		autoLoad: true,
  //		sortOptions,
  //		scrub(res) {
  //			res.data.results = res.data.results.map((inv) => new Invoice(inv));
  //		},
  //		onLoaded: (args) => $ctrl.onInvoicesLoaded(args),
  //	};
  //}
}
